import { API_URL, Status } from '../constants';
import { fetch } from '../fetchWrapper/fetch';
import { IUpdateVenueAddressBody } from '.';

export const updateVenueAddress = async (
  venueId: string,
  requestBody: IUpdateVenueAddressBody,
  addressId: string,
): Promise<void> => {
  const url = `${API_URL}/venues/${venueId}/address/${addressId}`;
  try {
    const res = await fetch(url, {
      method: 'PATCH',
      body: JSON.stringify(requestBody),
      headers: {
        'Content-Type': 'application/json',
      },
    });
    if (res.status !== Status.SUCCESS) {
      const json = await res.json();
      throw new Error(json.message);
    }
  } catch (e) {
    throw new Error(e || 'Unable to update address');
  }
};
